import { type KrakenErrorResponse } from "@krakentech/blueprint-api"

export function throwKrakenErrorResponse({
    errorCode,
    message = "",
}: {
    errorCode: string
    message?: string
}): never {
    throw {
        response: { errors: [{ extensions: { errorCode }, message }], data: {} },
    } satisfies KrakenErrorResponse
}
